import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

export interface FinTokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

@Injectable({ providedIn: 'root' })
export class FinApiService {
  private http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT);

  getFinToken(): Observable<FinTokenResponse> {
    return this.http.post<FinTokenResponse>(`${this.environment.origin.auth}/v1/fin/token`, {});
  }
}
